<ng-container *ngIf="alerts">
    <div class="alert-block" *ngFor="let alert of alerts" [@animate]>
        <div class="alert-wrapper">
            <div class="alert-inner">
                <div class="icon-block">
                    <i class="fa" [ngClass]="alert.icon"></i>
                </div>
                <div class="text-block">
                    <h5>{{ alert.title }}</h5>
                    <p [innerHtml]="alert.text"></p>
                </div>
                <div class="close-block" (click)="hide(alert)">
                    <i class="fal fa-times"></i>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<!-- [class.--hidden]="!alert" -->


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/alert/alert.template.html